import { render, staticRenderFns } from "./AppFooterDesktop.vue?vue&type=template&id=413bc83e"
import script from "./AppFooterDesktop.vue?vue&type=script&lang=js"
export * from "./AppFooterDesktop.vue?vue&type=script&lang=js"
import style0 from "./AppFooterDesktop.vue?vue&type=style&index=0&id=413bc83e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports